import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-form-field-toggle',
  templateUrl: './toggle-form-field.component.html',
  standalone: false,
})
export class ToggleFormFieldComponent extends DataTypeComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() data: any;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() editMode: boolean;

  public toggleActive: boolean;

  ngOnInit() {
    this.toggleActive = !!this.data;
  }
}
